import React, { useState } from 'react';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import TabHeader from '@/components/TabHeader/TabHeader';
import { useIsMobile } from '@/hooks';
import { TabView, TabPanel } from 'primereact/tabview';
import MobileTabHeader from './MobileTabHeader/MobileTabHeader';
import styles from './TabMenu.module.scss';

type Tabs = 'ship' | 'terminal' | 'coldHub' | 'roro';

interface TabData {
  key: Tabs;
  label: string;
  icon: IconDefinition;
  content: React.ReactNode;
}

interface TabMenuProps {
  tabs: TabData[];
}

export const TabMenu: React.FC<TabMenuProps> = ({ tabs }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const isMobile = useIsMobile();

  return (
    <TabView
      className={
        isMobile
          ? `${styles.mobileTabMenu} mobile-tab-menu`
          : `${styles.transparentTabMenu} transparent-tab-menu`
      }
      activeIndex={activeIndex}
      onTabChange={(e) => setActiveIndex(e.index)}
    >
      {tabs.map((tab, index) => (
        <TabPanel
          key={tab.key}
          header={
            isMobile ? (
              <MobileTabHeader
                active={activeIndex === index}
                label={tab.label}
                icon={tab.icon}
              />
            ) : (
              <TabHeader
                active={activeIndex === index}
                label={tab.label}
                icon={tab.icon}
              />
            )
          }
        >
          {tab.content}
        </TabPanel>
      ))}
    </TabView>
  );
};
